<template>
  <div>
    <LoadingModal :show="loading" :label="loadingLabel" :overlay="true" />
    <h1 class="u-m0">
            <span class="u-screenreader">
                Претрага по комисији
            </span>
    </h1>
    <form action="">
      <fieldset class="fieldset">
        <legend class="fieldset-legend">Претрага по комисији</legend>
        <div class="grid">
          <div class="grid-cell u-full u-xmed-auto fieldset-item">
            <label for="township" class="fieldset-label">Изаберите јединицу</label>
            <v-select v-model="selectedTownship" label="name" :options="townships" multiple>
              <template #no-options>
                Нема резултата за унету претрагу!
              </template>
            </v-select>
          </div>

          <div class="grid-cell u-full u-small-1of2 u-xmed-auto fieldset-item">
            <label for="date-from" class="fieldset-label">Датум од</label>
            <VueDatePicker
                v-model="date.from"
                :minDate="new Date(2015, 0, 1)" 
                :format="'dd.MM.yyyy.'"
                :enable-time-picker="false"
                :auto-apply="true"
                locale="sr"
                placeholder="Од датума"
                input-class-name="input"
            />
          </div>

          <div class="grid-cell u-full u-small-1of2 u-xmed-auto fieldset-item">
            <label for="date-to" class="fieldset-label">Датум до</label>
            <VueDatePicker
                v-model="date.to"
                :minDate="new Date(2015, 0, 1)" 
                :format="'dd.MM.yyyy.'"
                :enable-time-picker="false"
                :auto-apply="true"
                locale="sr"
                placeholder="До датума"
                input-class-name="input"
            />
          </div>

          <div class="grid-cell u-full u-xmed-auto fieldset-item fieldset-item--noLabel">
            <button @click.stop.prevent="submit" class="button button--fieldset">Тражи</button>
          </div>
        </div>

        <p class="fieldset-label u-mt40">Предложени/изабрани чланови комисије:</p>
        <ul>

          <li v-for="category in categories" :key="category.id">
            <input :value="category.id" v-model="checkedOrganizations" type="checkbox" class="checkbox"
                   :id="`category-${category.id}`">
            <label :for="`category-${category.id}`"
                   class="checkbox-label">{{ category.name }}</label>
          </li>

        </ul>
      </fieldset>
    </form>

    <div v-if="filteredData && filteredData.length > 0" class="results">
      <h2 class="h2">Резултати претраге:</h2>

      <div class="table-wrap">
        <table class="table  sortable-table  sticky-header">
          <thead>
          <tr class="table-row">
                        <th class="table-cell" @click="sortBy('organization')" style="cursor:pointer">
              {{ proposerColumnLabel }}
              <span :class="['sort-indicator', sortKey === 'organization' && 'sort-indicator--active']">{{ sortKey === 'organization' ? (sortOrder === 'asc' ? '▲' : '▼') : '↕' }}</span>
            </th>
            <th class="table-cell" @click="sortBy('township')" style="cursor:pointer">
              Општина/Град
              <span :class="['sort-indicator', sortKey === 'township' && 'sort-indicator--active']">{{ sortKey === 'township' ? (sortOrder === 'asc' ? '▲' : '▼') : '↕' }}</span>
            </th>
            <th class="table-cell" @click="sortBy('commissionMembers')" style="cursor:pointer">
              Предложени чланови комисије
              <span :class="['sort-indicator', sortKey === 'commissionMembers' && 'sort-indicator--active']">{{ sortKey === 'commissionMembers' ? (sortOrder === 'asc' ? '▲' : '▼') : '↕' }}</span>
            </th>
            <th class="table-cell" @click="sortBy('date_money')" style="cursor:pointer">
              Датум именовања комисије
              <span :class="['sort-indicator', sortKey === 'date_money' && 'sort-indicator--active']">{{ sortKey === 'date_money' ? (sortOrder === 'asc' ? '▲' : '▼') : '↕' }}</span>
            </th>
            <th class="table-cell" @click="sortBy('chosenMembers')" style="cursor:pointer">
              Изабрани чланови комисије
              <span :class="['sort-indicator', sortKey === 'chosenMembers' && 'sort-indicator--active']">{{ sortKey === 'chosenMembers' ? (sortOrder === 'asc' ? '▲' : '▼') : '↕' }}</span>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="contest in sortedData" :key="`${contest.organization?.id}-${contest.contestId}`" class="table-row">
             <td class="table-cell">
                {{ proposerName(contest) }}
            </td>
            <td class="table-cell">
              <router-link
                  :to="`/konkurs/${contest.contestId}${contest.township?.id ? '?jedinica=' + contest.township?.id : ''}#t`" 
              >
                {{ contest.township?.name || '—' }}
              </router-link>
            </td>
            <td class="table-cell">
              <ul>
                <li v-for="member in getSuggestedMembers(contest) || []" :key="member.id">
                  {{ member.name }}
                </li>
              </ul>
            </td>
            <td class="table-cell">
              <router-link
              :to="`/konkurs/${contest.contestId}#t`">
              {{ formatDateFront(contest?.date_money) }}
              </router-link>
            </td>
            <td class="table-cell">
              <ul>
                <li v-for="member in getChosenMembers(contest) || []" :key="member.id">
                  {{ member.name }}
                </li>
              </ul>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>


<script src="./Commission.js"></script>
<style scoped></style>
